import * as React from "react";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import Render from "source/app/presentation/Shared/Render";
import * as moment from "moment";

export function ShowFirstRecordText({
    isFirstRecord,
    date,
}: {
    isFirstRecord: boolean;
    date: string;
}) {
    const passedTimeText = moment(date).local().fromNow();

    return (
        <Render
            id="firstRecordText"
            when={isFirstRecord}
            withClasses={StyleClass(`firstRecordValueText`, {
                color: "white",
                fontSize: "10px",
                position: "absolute",
                opacity: 0.5,
                width: "100px",
                right: "-38px",
                bottom: "27px",
                zIndex: -1,
            })}
        >
            {passedTimeText}
            <div>▼</div>
        </Render>
    );
}
